<template>
  <div class="cover-height-wnav d-flex align-items-start align-items-md-center d-sm-block" id="home" ref="home">
    <b-container class="content-wrapper content-wrapper-hello d-flex align-items-center justify-content-center flex-column py-4">
      <div class="d-flex flex-column flex-md-row justify-content-center">
        <div class="picture-wrapper d-flex align-items-center">
          <div class="picture-frame">
            <b-img-lazy class="img-fluid" :src="require('@/assets/profile-picture.jpg')" alt="Hi! I'm Noemi Leon, Software Developer" >
            </b-img-lazy>
          </div>
        </div>
        <div class="right-side text-center text-md-left color-gray-med mt-4 mt-sm-3 mt-md-0">
          <small class="hello d-block d-md-none"> 
            Hello!!..   I'm
          </small>
          
          <small class="hello d-none d-md-block"> 
            Hello!!
          </small>
          <p class="mt-5 d-none d-md-block im"> I'm </p>
          <h1 class="color-pink-accent font-bad mt-4 mt-sm-2 mt-md-3 im"> Noemi Leon </h1>
          <div class="typewriter-container">
            <p class="font-code typewriter color-gray-dark mb-0">
              {{textToShow}}
            </p>
          </div>
          <div class="social-net mt-3 mt-md-5 mx-auto ml-md-0 d-flex justify-content-between">
            <a href="https://twitter.com/noeleo25" target="_blank" class="link-accent link-circle" rel="noreferrer"
            aria-label="Follow me on twitter">
              <i class="fab fa-twitter"></i>
            </a>
            <a href="https://github.com/noeleo25" target="_blank" class="link-accent link-circle" rel="noreferrer"
            aria-label="Check my github repository">
              <i class="fab fa-github-alt"></i>
            </a>
            <a href="https://www.linkedin.com/in/noemileonu/" target="_blank" class="link-accent link-circle" rel="noreferrer"
            aria-label="Contact me on LinkedIn">
              <i class="fab fa-linkedin-in"></i>
            </a>
          </div>
        </div>
      </div>
      <div class="text-center btn-wrapper">
        <CustomButton
          @click.native="showMore"
          class="white font-bad arrow-right-btn">
          <template>
            More..
          </template>
        </CustomButton>
      </div>  
    </b-container>
    
  </div>
</template>

<script>
import CustomButton from '@/components/CustomButton.vue'
export default {
  components: { CustomButton },
  data() {
    return {
      textToShow: '',
      scrollPos: 0,
    }
  },
  mounted(){
    this.initTypeWriter();
    window.addEventListener('scroll', this.handleScroll);
  },
  methods:{
    handleScroll(){
      if(window.scrollY == 0)
        this.initTypeWriter();
    },
    initTypeWriter(){
      this.textToShow = '';
      const text = 'Software Developer';
      var i = 0;
      var interval = setInterval(() => {
        this.textToShow += text.charAt(i);
        ++i;
        if(i == text.length){
          clearInterval(interval);
        }
      }, 200);
    },
    scrollToAbout(){
      const el = document.querySelector('#about');
      window.scrollTo({ top: el.offsetTop, behavior: 'smooth' });
    },
    showMore(){
      this.$emit('more');
      setTimeout(() => {
        this.scrollToAbout();
      }, 300);
    }
  }
}
</script>
<style>
.typewriter-container{
  height: 30px;
}
.typewriter{
  font-size: 22px;
  overflow: hidden;
  border-right: .10em solid #4F4F51;
  white-space: nowrap;
  line-height: 1;
  word-break: break-all;
  display:inline-block;
  animation: 
  typing 3.5s steps(30, end),
  blink-caret .5s step-end infinite;
}
@keyframes typing {
  from { width: 0 }
  to { width: 100% }
}
@keyframes blink-caret {
  from, to { border-color: transparent }
  50% { border-color: #4F4F51 }
}
small.hello{
  font-size: 20px;
  text-transform: uppercase;
}
.im{
  font-size: 24px;
  font-weight: bold;
}
h1.im{
  font-size: 2.5rem;
}
.btn-wrapper{
  margin-top: 3rem;
}
.picture-wrapper{
  /*width:100%;*/
  justify-content: center;
}
.picture-frame{
  width: 120px;
  height: 120px;

}
.picture-frame > img{
  width: inherit;
  height: inherit;
  object-fit: cover;
  border-radius: 50%;
}
@media (min-width: 768px) {   
  .picture-frame{
    border: 4px solid var(--pink-accent);
    position: relative;
    width: 300px;
    height: 370px;
  }
  .picture-frame > img{
    position: absolute;
    top: -45px;
    left: 28px;
    border: 1px solid #D6D6D6;
    border-radius: 0;
  }
  .right-side{
    margin-left: 5rem;
  }
  .btn-wrapper{
    margin-top: 5rem;
  }
  .content-wrapper-hello{
    height: 100%;
  }
}
</style>